import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Switch from 'flarum/common/components/Switch';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import Button from 'flarum/common/components/Button';
import { initiateNewDiscussion } from '../utils/discussionUtils';
export default class InactiveDiscussionAlert extends Component {
  /** Set when the user toggles, so focus can follow the control that replaced the one they used. */
  refocus = false;
  view() {
    const lastPostedAt = this.attrs.discussion.lastPostedAt();
    const time = lastPostedAt ? dayjs(lastPostedAt).fromNow() : null;

    // Once the user has confirmed, shrink to a single line so the editor gets its space back.
    if (this.attrs.checked) {
      return m("div", {
        className: "NecrobumpingAlert NecrobumpingAlert--confirmed Alert Alert--warning",
        role: "status"
      }, m("div", {
        className: "Alert-body NecrobumpingAlert-content"
      }, m(Icon, {
        name: "fas fa-clock",
        className: "NecrobumpingAlert-icon"
      }), m("span", {
        className: "NecrobumpingAlert-message"
      }, app.translator.trans('fof-prevent-necrobumping.forum.composer.inactive_discussion_alert.confirmed')), m(Button, {
        className: "Button Button--link NecrobumpingAlert-undo",
        onclick: this.onchange.bind(this)
      }, app.translator.trans('fof-prevent-necrobumping.forum.composer.inactive_discussion_alert.undo'))));
    }
    return m("div", {
      className: "NecrobumpingAlert Alert Alert--warning"
    }, m("div", {
      className: "Alert-body"
    }, m("div", {
      className: "NecrobumpingAlert-content"
    }, m("div", {
      className: "NecrobumpingAlert-icon"
    }, m(Icon, {
      name: "fas fa-clock"
    })), m("div", {
      className: "NecrobumpingAlert-message"
    }, m("strong", {
      className: "NecrobumpingAlert-title"
    }, app.translator.trans('fof-prevent-necrobumping.forum.composer.inactive_discussion_alert.title', {
      time
    })), m("div", {
      className: "NecrobumpingAlert-details"
    }, m("p", {
      className: "NecrobumpingAlert-description"
    }, app.translator.trans('fof-prevent-necrobumping.forum.composer.inactive_discussion_alert.description')), app.forum.attribute('fof-prevent-necrobumping.show_discussion_cta') && app.forum.attribute('canStartDiscussion') && m("p", null, app.translator.trans('fof-prevent-necrobumping.forum.composer.inactive_discussion_alert.cta'), ' ', m(Link, {
      onclick: e => {
        e.preventDefault();
        initiateNewDiscussion();
      }
    }, app.translator.trans('fof-prevent-necrobumping.forum.composer.inactive_discussion_alert.cta_button'))), m("div", {
      className: "NecrobumpingAlert-checkbox"
    }, m(Switch, {
      state: false,
      onchange: this.onchange.bind(this)
    }, app.translator.trans('fof-prevent-necrobumping.forum.composer.inactive_discussion_alert.confirmation'))))))));
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    if (this.refocus) {
      this.refocus = false;
      this.$(this.attrs.checked ? '.NecrobumpingAlert-undo' : 'input').trigger('focus');
    }
  }
  onchange() {
    this.refocus = true;
    this.attrs.set(!this.attrs.checked);
  }
}
flarum.reg.add('fof-prevent-necrobumping', 'forum/components/InactiveDiscussionAlert', InactiveDiscussionAlert);